export const QUICK_ACTIONS_COPY_PREFIX = 'logged_out_homepage.quick_actions';
export const MOBILE_COPY_SUFFIX = '_mobile';
export const SEARCH_BAR_SOURCE = 'quick_actions';
export const MIRA_SOURCE = 'logged_out_homepage';
export const MIRA_VARIATION = 'quick_actions';
export const MIRA_PROMPT = '';
